import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import countryList from 'react-select-country-list';


class Country extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: countryList().getData()
    };
    const { isRequired, updateFieldErrors, answer, noDefault } = this.props;
    this.focused = false;
    if (noDefault && isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors
    } = this.props;
    handleValueChange(value, fieldId);
    let updatedErrors = [];

    if (!value) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }

  render() {
    const { fieldId, answer, customField, full_width } = this.props;
    const { options } = this.state;
    return (
      <div style={{ width: (!full_width && customField)? '453px' : '' }}>
        <Select
          options={options}
          value={answer}
          onChange={e => this.handleAnswerChanged(e, fieldId)}
        />
      </div>
    );
  }
}

Country.defaultProps = {
  answer: undefined
};

Country.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};

export default Country;
